export const TID = {
  addTaskBtn: "add-task-btn",
  headerCompany: "header-company",
  headerDate: "header-date",
  headerSync: "header-sync",
  headerDbStatus: "header-db-status",
  kpiTotal: "kpi-total",
  kpiPending: "kpi-pending",
  kpiCompleted: "kpi-completed",
  kpiOverdue: "kpi-overdue",
  tabTax: "tab-tax",
  tabSecretarial: "tab-secretarial",
  searchInput: "search-input",
  filterAll: "filter-all",
  filterPending: "filter-pending",
  filterCompleted: "filter-completed",
  filterDueSoon: "filter-due-soon",
  filterOverdue: "filter-overdue",
  complianceTable: "compliance-table",
  taskRow: (id) => `task-row-${id}`,
  taskTitle: (id) => `task-title-${id}`,
  taskToggle: (id) => `task-toggle-${id}`,
  taskEdit: (id) => `task-edit-${id}`,
  taskDelete: (id) => `task-delete-${id}`,
  taskUpload: (id) => `task-upload-${id}`,
  taskView: (id) => `task-view-${id}`,
  taskRemoveDoc: (id) => `task-remove-doc-${id}`,
  addModal: "add-task-modal",
  addTitle: "add-title-input",
  addCategory: "add-category-select",
  addDueDate: "add-due-date",
  addStatus: "add-status-select",
  addSubmit: "add-submit-btn",
  addCancel: "add-cancel-btn",
  editModal: "edit-task-modal",
  editTitle: "edit-title-input",
  editCategory: "edit-category-select",
  editDueDate: "edit-due-date",
  editStatus: "edit-status-select",
  editSubmit: "edit-submit-btn",
  editCancel: "edit-cancel-btn",
  deleteConfirm: "delete-confirm-btn",
  deleteCancel: "delete-cancel-btn",
  sortDue: "sort-due",
  sortTitle: "sort-title",
  sortStatus: "sort-status",
  sortUpdated: "sort-updated",
  emptyState: "empty-state",
  addFirstTask: "add-first-task-btn",
  // View switcher
  viewList: "view-list",
  viewCalendar: "view-calendar",
  // Export
  exportBtn: "export-btn",
  exportCsv: "export-csv",
  exportXlsx: "export-xlsx",
  // Calendar
  calendarPrev: "calendar-prev",
  calendarNext: "calendar-next",
  calendarToday: "calendar-today",
  calendarLabel: "calendar-label",
  calendarDay: (iso) => `calendar-day-${iso}`,
  calendarSidebar: "calendar-sidebar",
  // Templates
  templatesBtn: "templates-btn",
  templatesModal: "templates-modal",
  templateNew: "template-new-btn",
  templateItem: (id) => `template-item-${id}`,
  templateEdit: (id) => `template-edit-${id}`,
  templateDelete: (id) => `template-delete-${id}`,
  templateGenerate: (id) => `template-generate-${id}`,
  templateToggle: (id) => `template-toggle-${id}`,
  templateFormModal: "template-form-modal",
  templateFormTitle: "template-form-title",
  templateFormCategory: "template-form-category",
  templateFormRecurrence: "template-form-recurrence",
  templateFormDay: "template-form-day",
  templateFormAnchor: "template-form-anchor",
  templateFormSubmit: "template-form-submit",
  templateFormCancel: "template-form-cancel",
  generateModal: "generate-modal",
  generateCount: "generate-count",
  generateStart: "generate-start",
  generateSubmit: "generate-submit",
  generateCancel: "generate-cancel",
  // Master compliance library
  libraryBtn: "library-btn",
  libraryModal: "library-modal",
  libraryTab: (k) => `library-tab-${k}`,
  librarySearch: "library-search",
  librarySave: "library-save",
  libraryRegenerate: "library-regenerate",
  libraryClose: "library-close",
  libraryCell: (clientId, code) => `library-cell-${clientId}-${code}`,
  libraryRuleRow: (code) => `library-rule-${code}`,
  libraryChangesBadge: "library-changes-badge",
  // Clients
  clientsPage: "clients-page",
  addClientBtn: "add-client-btn",
  clientsSearch: "clients-search",
  clientRow: (id) => `client-row-${id}`,
  clientOpen: (id) => `client-open-${id}`,
  clientEdit: (id) => `client-edit-${id}`,
  clientDelete: (id) => `client-delete-${id}`,
  clientForm: "client-form-modal",
  clientFormName: "client-form-name",
  clientFormType: "client-form-type",
  clientFormPan: "client-form-pan",
  clientFormGstin: "client-form-gstin",
  clientFormEmail: "client-form-email",
  clientFormContact: "client-form-contact",
  clientFormNotes: "client-form-notes",
  clientFormGenerate: "client-form-generate",
  clientFormMonths: "client-form-months",
  clientFormHasGstn: "client-form-has-gstn",
  clientFormHasTan: "client-form-has-tan",
  clientFormSubmit: "client-form-submit",
  clientFormCancel: "client-form-cancel",
  clientSelect: (id) => `client-select-${id}`,
  clientSelectAll: "client-select-all",
  clientsBulkBar: "clients-bulk-bar",
  clientsBulkDelete: "clients-bulk-delete",
  tasksBulkBar: "tasks-bulk-bar",
  tasksBulkDelete: "tasks-bulk-delete",
  taskSelect: (id) => `task-select-${id}`,
  taskSelectAll: "task-select-all",
  taskRemarks: (id) => `task-remarks-${id}`,
  editRemarks: "edit-remarks",
  addRemarks: "add-remarks",
  bulkConfirmDialog: "bulk-confirm-dialog",
  bulkConfirmCta: "bulk-confirm-cta",
  // Client dashboard
  clientBackBtn: "client-back-btn",
  clientHeaderName: "client-header-name",
  clientHeaderEdit: "client-header-edit",
  applyPackBtn: "apply-pack-btn",
  // Bulk import
  importClientsBtn: "import-clients-btn",
  importModal: "import-clients-modal",
  importDownloadTemplate: "import-download-template",
  importFileInput: "import-file-input",
  importFileDrop: "import-file-drop",
  importGenerate: "import-generate",
  importMonths: "import-months",
  importSkipDup: "import-skip-dup",
  importSubmit: "import-submit",
  importCancel: "import-cancel",
  importResultCreated: "import-result-created",
  importResultSkipped: "import-result-skipped",
  importResultFailed: "import-result-failed",
  importDone: "import-done",
  // Settings
  settingsBtn: "settings-btn",
  settingsModal: "settings-modal",
  settingsEnabled: "settings-enabled",
  settingsRecipients: "settings-recipients",
  settingsSave: "settings-save",
  settingsTestEmail: "settings-test-email",
  settingsSendTest: "settings-send-test",
  settingsRunNow: "settings-run-now",
};
